import { createContext, useMemo, useState, type ReactNode } from 'react';

type ProjectAddExitContextValue = {
  exitIntentNavigateTo: string | null;
  requestProjectAddExit: (navigateTo?: string | null) => void;
  clearProjectAddExit: () => void;
};

type ProjectAddExitProviderProps = {
  children?: ReactNode;
};

export const ProjectAddExitContext = createContext<ProjectAddExitContextValue>({
  exitIntentNavigateTo: null,
  requestProjectAddExit: () => undefined,
  clearProjectAddExit: () => undefined,
});

const ProjectAddExitContextProvider: React.FC<ProjectAddExitProviderProps> = ({ children }) => {
  const [exitIntentNavigateTo, setExitIntentNavigateTo] = useState<string | null>(null);

  const value = useMemo(
    () => ({
      exitIntentNavigateTo,
      requestProjectAddExit: (navigateTo?: string | null) => {
        setExitIntentNavigateTo(navigateTo ?? null);
      },
      clearProjectAddExit: () => {
        setExitIntentNavigateTo(null);
      },
    }),
    [exitIntentNavigateTo]
  );

  return <ProjectAddExitContext.Provider value={value}>{children}</ProjectAddExitContext.Provider>;
};

export default ProjectAddExitContextProvider;
